import { ListenableEvent, Log } from "../../utils";
import { ERR_INVALID_ARGUMENT, ERR_NOT_AVAILABLE } from "../../utils/error";
var ToolManager = /** @class */ (function () {
    function ToolManager() {
        this.eventToolStarted = new ListenableEvent(this);
        this.eventToolStopped = new ListenableEvent(this);
        this.eventInteractorTriggered = new ListenableEvent(this);
        this.mDefaultTool = null;
        this.mActiveTool = null;
        this.mActiveDraggerInteractor = null;
        this.mActiveDraggerPointerId = null;
    }
    Object.defineProperty(ToolManager.prototype, "activeTool", {
        get: function () {
            return (this.mActiveTool);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ToolManager.prototype, "defaultTool", {
        get: function () {
            return (this.mDefaultTool);
        },
        set: function (pTool) {
            this.mDefaultTool = pTool;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts pTool and stops the current active tool.
     */
    ToolManager.prototype.startTool = function (pTool, pToolParameter) {
        if (pToolParameter === void 0) { pToolParameter = null; }
        if (pTool == null)
            throw (new Error(ERR_INVALID_ARGUMENT));
        if (!pTool.isAvailable())
            throw (new Error(ERR_NOT_AVAILABLE));
        var tStarted = pTool.start(pToolParameter);
        if (tStarted) {
            this.stopTool(this.mActiveTool);
            this.mActiveTool = pTool;
            this.eventToolStarted.trigger(pTool);
        }
        return (tStarted);
    };
    ToolManager.prototype.stopActiveTool = function () {
        this.stopTool(this.mActiveTool);
        this.startDefaultTool();
    };
    ToolManager.prototype.startDefaultTool = function () {
        if (this.mDefaultTool == null)
            return (false);
        if (this.isDefaultToolRunning())
            return (true); //already running
        return (this.startTool(this.mDefaultTool, null));
    };
    ToolManager.prototype.isDefaultToolRunning = function () {
        return (this.mActiveTool != null && this.mActiveTool === this.mDefaultTool);
    };
    Object.defineProperty(ToolManager.prototype, "_activeDraggerInteractor", {
        //// internal //////////////////////////////////////////////////////////////////////////////
        /** @internal */
        get: function () {
            return (this.mActiveDraggerInteractor);
        },
        enumerable: false,
        configurable: true
    });
    /** @internal */
    ToolManager.prototype._updateActiveToolState = function () {
        if (this.mActiveTool != null && !this.mActiveTool.isRunning()) {
            this.mActiveTool = null;
            this.startDefaultTool();
        }
    };
    /** @internal */
    ToolManager.prototype._handlePointerDown = function (pEvent, pState) {
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handlePointerDown(pEvent, pState);
    };
    /** @internal */
    ToolManager.prototype._handlePointerUp = function (pEvent, pState) {
        this.finishInteractorDragging(pEvent);
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handlePointerUp(pEvent, pState);
    };
    /** @internal */
    ToolManager.prototype._handlePointerDblClick = function (pEvent, pState) {
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handlePointerDblClick(pEvent, pState);
    };
    /** @internal */
    ToolManager.prototype._handlePointerMove = function (pEvent, pState) {
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handlePointerMove(pEvent, pState);
    };
    /** @internal */
    ToolManager.prototype._handlePointerCancel = function (pEvent, pState) {
        this.finishInteractorDragging(pEvent);
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handlePointerCancel(pEvent, pState);
    };
    /** @internal */
    ToolManager.prototype._handleKeyUp = function (pEvent, pState) {
        var tTool = this.getActiveRunningTool();
        if (tTool != null)
            tTool.handleKeyUp(pEvent, pState);
        //esc -> abort active tool
        if (pEvent.which === 27)
            this.startDefaultTool();
    };
    /** @internal */
    ToolManager.prototype._setActiveDraggerInteractor = function (pDragger, pPointerId) {
        this.mActiveDraggerInteractor = pDragger;
        this.mActiveDraggerPointerId = pPointerId;
    };
    ToolManager.prototype.stopTool = function (pTool) {
        if (pTool == null)
            return;
        try {
            if (pTool.isRunning()) {
                pTool.stop();
                this.eventToolStopped.trigger(pTool);
            }
        }
        catch (e) {
            Log.error("Failed to stop tool.", e);
        }
    };
    ToolManager.prototype.getActiveRunningTool = function () {
        if (this.mActiveTool != null && this.mActiveTool.isRunning())
            return (this.mActiveTool);
        return (null);
    };
    ToolManager.prototype.finishInteractorDragging = function (pEvent) {
        if (this.mActiveDraggerPointerId === pEvent.pointerId && this.mActiveDraggerInteractor != null) {
            var tDragger = this.mActiveDraggerInteractor;
            this.mActiveDraggerInteractor = null;
            this.mActiveDraggerPointerId = null;
            tDragger._finishDragging();
        }
    };
    return ToolManager;
}());
export { ToolManager };
